"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var check_1 = require("../check");
var CheckboxGroup_1 = require("./CheckboxGroup");
exports.Checkbox = forward_ref_with_statics_1.forwardRefWithStatics(function (props, ref) {
    return react_1.default.createElement(check_1.Check, tslib_1.__assign({ ref: ref, type: "checkbox" }, props));
}, 
// statics
{
    Group: CheckboxGroup_1.CheckboxGroup,
});
exports.Checkbox.displayName = "Checkbox";
//# sourceMappingURL=Checkbox.js.map